import _ from 'lodash'
import ActionEvent from './lib/ActionEvent'
import CustomAction from './lib/CustomAction'
import HttpRequest from './lib/HttpRequest'
import services from './services'
import utilities from './utilities'

const actions = {}

services.forEach((options) => {
  const service = options.name
  const version = options.version
  const api = new HttpRequest(service, version)
  const stateKey = _.camelCase(service)

  if (options.restful === false) {
    return
  }

  actions[`${service}/all`] = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit('isAllPending', { stateKey, pending: true })
      commit('errorOnAll', { stateKey, error: undefined })

      const params = {}

      if (_.has(payload, 'populate')) {
        params.populate = payload.populate
      }

      if (_.has(payload, 'query')) {
        _.merge(params, utilities.formatQueryParam(payload.query))

        _.unset(payload, 'query')
      }

      api.get('all', params)
        .then(res => {
          commit('entities', { stateKey, data: res.data })
          commit('isAllPending', { stateKey, pending: false })

          ActionEvent.$emit(`${service}.all`, res.data)

          resolve(res.data)
        })
        .catch(({ response }) => {
          commit('error', _.merge(response.data, { stateKey }))
          commit('errorOnAll', { stateKey, error: _.get(response.data, 'message') })
          commit('isAllPending', { stateKey, pending: false })

          reject(response.data)
        })
    })
  }

  actions[`${service}/list`] = ({ commit }, payload = {}) => {
    return new Promise((resolve, reject) => {
      commit('isListPending', { stateKey, pending: true })
      commit('errorOnList', { stateKey, error: undefined })

      const params = {}

      if (_.has(payload, 'query')) {
        _.merge(params, utilities.formatQueryParam(payload.query))

        _.unset(payload, 'query')
      }

      _.merge(params, payload)

      api.get('', params)
        .then(res => {
          commit('list', { stateKey, data: res.data })
          commit('isListPending', { stateKey, pending: false })

          ActionEvent.$emit(`${service}.list`, res.data)

          resolve(res.data)
        })
        .catch(({ response }) => {
          commit('error', _.merge(response.data, { stateKey }))
          commit('errorOnList', { stateKey, error: _.get(response.data, 'message') })
          commit('isListPending', { stateKey, pending: false })

          reject(response.data)
        })
    })
  }

  actions[`${service}/get`] = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      commit('isGetPending', { stateKey, pending: true })
      commit('errorOnGet', { stateKey, error: undefined })

      api.get(id)
        .then(res => {
          commit('entity', { stateKey, data: res.data })
          commit('isGetPending', { stateKey, pending: false })

          ActionEvent.$emit(`${service}.get`, res.data)

          resolve(res.data)
        })
        .catch(({ response }) => {
          commit('error', _.merge(response.data, { stateKey }))
          commit('errorOnGet', { stateKey, error: _.get(response.data, 'message') })
          commit('isGetPending', { stateKey, pending: false })

          reject(response.data)
        })
    })
  }

  actions[`${service}/create`] = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit('isCreatePending', { stateKey, pending: true })
      commit('errorOnCreate', { stateKey, error: undefined })

      api.post('', payload)
        .then(res => {
          commit('entity', { stateKey, data: res.data })
          commit('isCreatePending', { stateKey, pending: false })

          ActionEvent.$emit(`${service}.create`, res.data)

          resolve(res.data)
        })
        .catch(({ response }) => {
          commit('error', _.merge(response.data, { stateKey }))
          commit('errorOnCreate', { stateKey, error: _.get(response.data, 'message') })
          commit('isCreatePending', { stateKey, pending: false })

          reject(response.data)
        })
    })
  }

  actions[`${service}/update`] = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit('isUpdatePending', { stateKey, pending: true })
      commit('errorOnUpdate', { stateKey, error: undefined })

      api.put(_.get(payload, '_id'), payload)
        .then(res => {
          commit('entity', { stateKey, data: res.data })
          commit('isUpdatePending', { stateKey, pending: false })

          ActionEvent.$emit(`${service}.update`, res.data)

          resolve(res.data)
        })
        .catch(({ response }) => {
          commit('error', _.merge(response.data, { stateKey }))
          commit('errorOnUpdate', { stateKey, error: _.get(response.data, 'message') })
          commit('isUpdatePending', { stateKey, pending: false })

          reject(response.data)
        })
    })
  }

  actions[`${service}/save`] = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit('isSavePending', { stateKey, pending: true })
      commit('errorOnSave', { stateKey, error: undefined })

      api.save(payload)
        .then(res => {
          commit('entity', { stateKey, data: res.data })
          commit('isSavePending', { stateKey, pending: false })

          ActionEvent.$emit(`${service}.save`, res.data)

          resolve(res.data)
        })
        .catch(({ response }) => {
          commit('error', _.merge(response.data, { stateKey }))
          commit('errorOnSave', { stateKey, error: _.get(response.data, 'message') })
          commit('isSavePending', { stateKey, pending: false })

          reject(response.data)
        })
    })
  }

  actions[`${service}/remove`] = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      commit('isRemovePending', { stateKey, pending: true })
      commit('errorOnRemove', { stateKey, error: undefined })

      api.destroy(id)
        .then(res => {
          commit('removed', { stateKey, data: res.data })
          commit('isRemovePending', { stateKey, pending: false })

          ActionEvent.$emit(`${service}.remove`, res.data)

          resolve(res.data)
        })
        .catch(({ response }) => {
          commit('error', _.merge(response.data, { stateKey }))
          commit('errorOnRemove', { stateKey, error: _.get(response.data, 'message') })
          commit('isRemovePending', { stateKey, pending: false })

          reject(response.data)
        })
    })
  }

  if (options.hasMeta) {
    actions[`${service}/meta/set`] = ({ commit, dispatch, state }, { key, value }) => {
      const entity = state[stateKey].entity
      const _id = _.get(entity, '_id')
      const meta = _.has(entity, 'meta') && _.isPlainObject(entity.meta) ? _.cloneDeep(entity.meta) : {}

      _.set(meta, key, value)

      return dispatch(`${service}/update`, {
        _id,
        meta
      })
    }
  }

  options.customActions.forEach(opts => {
    const CA = new CustomAction(opts)

    actions[`${service}/${CA.getAction()}`] = ({ commit }, payload = {}) => {
      return new Promise((resolve, reject) => {
        commit(`${service}/errorOn${CA.getMutationStatusFormat()}`, { message: undefined })
        commit(`${service}/is${CA.getMutationStatusFormat()}Pending`, true)

        api[CA.getMethod()](CA.getEndpoint(payload), payload)
          .then(({ data }) => {
            commit(`${service}/${CA.getMutationFormat()}`, data)
            commit(`${service}/is${CA.getMutationStatusFormat()}Pending`, false)

            resolve(data)
          })
          .catch(({ response }) => {
            commit(`${service}/errorOn${CA.getMutationStatusFormat()}`, response.data)
            commit(`${service}/is${CA.getMutationStatusFormat()}Pending`, false)

            reject(response.data)
          })
      })
    }
  })

  options.hasMany.forEach(relation => {
    actions[`${service}/${relation}/add`] = ({ dispatch, state }, { _id }) => {
      const entities = _.get(state[stateKey].entity, relation) || []
      const value = entities.length && _.isString(entities[0]) ? entities.concat(_id) : _.map(entities, '_id').concat(_id)
      const payload = { _id: state[stateKey].entity._id }

      _.set(payload, relation, value)

      return dispatch(`${service}/update`, payload)
    }

    actions[`${service}/${relation}/pull`] = ({ dispatch, state }, { _id }) => {
      const entities = _.cloneDeep(_.get(state[stateKey].entity, relation) || [])
      const entity = entities.find(resource => resource._id === _id)

      if (entity) {
        const payload = { _id: state[stateKey].entity._id }
        const index = entities.indexOf(entity)

        entities.splice(index, 1)

        _.set(payload, relation, _.map(entities, '_id'))

        return dispatch(`${service}/update`, payload)
      }
    }
  })
})

utilities.mergeActionExtensions(actions)

export default actions
